var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoAlbumSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 157,
    viewBox: "0 0 157 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.083 1H13.9167C6.78301 1 1 6.78301 1 13.9167V143.083C1 150.217 6.78301 156 13.9167 156H143.083C150.217 156 156 150.217 156 143.083V13.9167C156 6.78301 150.217 1 143.083 1Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6665 74.1949C64.5558 74.1949 74.1942 64.5565 74.1942 52.6671C74.1942 40.7778 64.5558 31.1393 52.6665 31.1393C40.7771 31.1393 31.1387 40.7778 31.1387 52.6671C31.1387 64.5565 40.7771 74.1949 52.6665 74.1949Z",
    fill: "currentColor",
    fillOpacity: 0.05,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M156 130.166L108.639 87.1106L65.5833 125.861L35.4444 100.027L1 125.861",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAlbumSingle);
export default __webpack_public_path__ + "static/media/no-album-single.2773d6bfc51bced5d890cfd83d9c4e9e.svg";
export { ForwardRef as ReactComponent };